import { connect } from 'react-redux';
import ButtonWidget from 'nucleus-widgets/lib/Button/ButtonWidget';
import { openAlreadyRegisteredDialog } from '../containers/AlreadyRegisteredDialog';
import { defaultMemoize } from 'reselect';
import { bindActionCreators } from 'redux';
import { getAssociatedRegistrationPathId } from '../redux/modules/selectors/shared';
import { canLogin, canRegister } from '../redux/modules/selectors/currentRegistrant';
import { canWaitlist } from '../redux/modules/selectors/event';
import { promptToStartNewRegistration } from '../redux/modules/registrationForm/actions';

function createLinkClickHandler(title, registerNowText) {
  return () => (dispatch) => {
    dispatch(openAlreadyRegisteredDialog({
      title,
      registerNowText
    }));
  };
}

export function mapStateToProps(state, props) {
  const { userSession: { isPlanner, isPreview }, event: { isArchived } } = state;
  const buttonDisabled = (isArchived ||
    (!canRegister(state) &&
     !canWaitlist(state,
       getAssociatedRegistrationPathId(state, state.userSession.defaultRegTypeId)))) &&
       !isPlanner && !isPreview;
  const linkDisabled = (isArchived || !canLogin(state)) &&
    !isPlanner && !isPreview;

  const mappedProps = {
    disabled: buttonDisabled,
    kind: 'button'
  };

  if (linkDisabled) {
    mappedProps.config = {
      ...props.config,
      link: {
        enabled: false,
        text: ''
      }
    };
  }
  return mappedProps;
}
export const mapDispatchToProps = () => {
  const memoizedCreateLinkClickHandler = defaultMemoize(createLinkClickHandler);
  return (dispatch, props) => {
    const registerNowText = props.config.text.htmlContent ?
      props.config.text.htmlContent.replace(/<[^>]*>/g, '') : props.config.text;
    const actions = {
      clickHandler: promptToStartNewRegistration,
      linkClickHandler: memoizedCreateLinkClickHandler(props.config.link.text, registerNowText)
    };
    return bindActionCreators(actions, dispatch);
  };
};

/**
* Data wrapper for the event register now widget.
*/
export default connect(mapStateToProps, mapDispatchToProps)(ButtonWidget);



// WEBPACK FOOTER //
// ./src/widgets/RegisterNowWidget.js